/** The photo a horizontal swipe moves to: 1 (next) for a move left of at least `threshold` px, -1 for one to the right,
 *  0 for a shorter or mostly vertical move, which stays the page's scroll. */
export function swipeStep(dx: number, dy: number, threshold = 40): -1 | 0 | 1 {
  if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy)) return 0;
  return dx < 0 ? 1 : -1;
}
